module.exports = __webpack_public_path__ + "img/auth-pattern.de482b49.png";